import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import DarasaComp from './DarasaComp'

function Darassa() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <DarasaComp/>      
        </div>
    </div>
  )
}

export default Darassa